import React from "react";
import { createPortal } from "react-dom";
import Avatar from "../Avatar/Avatar";
import "./UserPopup.css";

const UserPopup = ({ user, isVisible, position }) => {
  if (!isVisible || !user) return null;

  return createPortal(
    <div
      className="user-popup"
      style={{
        position: "fixed",
        top: position.top,
        left: position.left,
        zIndex: 1000,
      }}
    >
      <div className="user-popup-content">
        <div className="user-popup-avatar">
          <Avatar user={user} name={user.email} size={32} />
        </div>
        <div className="user-popup-info">
          <div className="user-popup-email">{`${user.firstName || "Имя"} ${
            user.lastName || "Фамилия"
          }`}</div>
          {user.nickname && (
            <div className="user-popup-nickname">{user.nickname}</div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UserPopup;
